module.exports = __webpack_public_path__ + "img/win-install-2.21741af4.svg";